export default {
    config: {
        defaultWidth: 200
    },
    default: {
        label: 'Location'
    },
    unique: [],
    sort: 'inventory.location',
    lang: {
        name: 'Inventory Location',
        category: ['User', 'Collection'],
        description: 'Storage location of the collection item (Deep Sync data; only visible if owner has shared their inventory location).',
        views: ['list', 'sheet'],
    },
    filters: ['inventory.location.text', 'has.inventory.location']
}
